import { FormBuilderMetaFlags, IFixedRuleType } from '@framework/engine';
import { t } from '@framework/i18n';
import { yup } from '@framework/validation';
import { IEmailVerificationWidget } from './IEmailVerificationWidget';

export function emailVerificationWidgetStateFieldName(code: string) {
  return `${code}@state`;
}

export enum EmailVerificationState {
  NotVerified = 'not-verified',
  Verifying = 'verifying',
  Verified = 'verified',
}

export function createEmailVerificationWidgetFormSchema(input: {
  widget: IEmailVerificationWidget;
}) {
  const { widget } = input;

  const verificationStateName = emailVerificationWidgetStateFieldName(
    widget.code,
  );

  const stateSchema = yup
    .string()
    .default(EmailVerificationState.NotVerified)
    .oneOfEnum(EmailVerificationState)
    .formBuilderFlags(
      FormBuilderMetaFlags.SkipValidationRules,
      FormBuilderMetaFlags.SkipDefaultValue,
    );

  return {
    [widget.code]: yup.string().email(),
    [verificationStateName]: stateSchema,
  };
}

/**
 * Regola fissa per validare che il campo sia stato verificato.
 * Solo lato FE, lato BE è replicato.
 */
export const EmailVerificationWidgetRule: IFixedRuleType = {
  name: 'Verifica E-Mail',
  validator: (schema, widget) => {
    const emailWidget = widget as unknown as IEmailVerificationWidget;
    const verificationStateName = emailVerificationWidgetStateFieldName(
      emailWidget.code,
    );

    return schema.when(
      [verificationStateName],
      ([verificationState], schema) => {
        const applyRules = schema.meta?.()?.applyRules ?? true;
        if (!applyRules) return schema;

        if (verificationState !== EmailVerificationState.Verified) {
          return schema.test({
            name: 'email-verified',
            skipAbsent: true,
            message: t(
              'email-verification-rule.message',
              `È necessario verificare l'email per proseguire`,
            ),
            test: () => false,
          });
        }

        return schema;
      },
    );
  },
};
